import { useMediaQuery, useTheme } from "@mui/material";

/**
 * True when the window is at least `md` (900px) wide — the one place the app
 * decides "desktop" from "phone".
 *
 * `md` rather than `sm`: a 600-900px browser window overflows a desktop layout
 * exactly as a phone does, so the two want the same treatment. Ten components
 * had written `useMediaQuery(theme.breakpoints.up("md"))` out by hand before
 * this existed; a layout that reads the breakpoint from here cannot drift from
 * the layout next to it.
 *
 * This answers about WIDTH only. A widget that must also survive a phone in
 * landscape — short, but wider than `sm` — asks `fullScreenPanelQuery`
 * (`components/support/support-panel-layout.ts`) instead, which reads both axes.
 */
export const useIsDesktop = (): boolean => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.up("md"));
};
